import React, { useState } from "react";
import SplineChart from "./components/SplineChart";
import BarChart from "./components/BarChart";
import BarChartContactUs from "./components/BarChartContactUs";
import BarChartTouch from "./components/BarChartTouch";
import BarChartServiceBooking from "./components/BarChartServiceBooking";
import BarChartLoan from "./components/BarChartLoan";

function DashboardPage() {
    const [propertyYear, setPropertyYear] = useState("2026");
    const [loanYear, setLoanYear] = useState("2026");
    const [contactYear, setContactYear] = useState("2026");
    const [touchYear, setTouchYear] = useState("2026");

    return (
        <div className="min-h-screen p-6 bg-gray-100">
            <div className="max-w-7xl mx-auto space-y-8">

                <SplineChart 
                    propertyYear={propertyYear} 
                    contactYear={contactYear} 
                    touchYear={touchYear} 
                />

                <div className="flex gap-4 flex-wrap">
                    <div className="flex-1 min-w-[300px]">
                        <BarChartTouch onYearChange={setTouchYear} />
                    </div>
                    <div className="flex-1 min-w-[300px]">
                        <BarChartContactUs onYearChange={setContactYear} />
                    </div>
                </div>

                <BarChart onYearChange={setPropertyYear} />

                <BarChartServiceBooking />

                <BarChartLoan onYearChange={setLoanYear} />

            </div>
        </div>
    );
}

export default DashboardPage;